import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService, PermissionsService } from '../providers';

@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
  standalone: false,
})
export class TabBarComponent implements OnInit {
  @ViewChild('buttonHome', { read: ElementRef })
  buttonHome: ElementRef<HTMLElement>;
  @ViewChild('buttonSettings', { read: ElementRef })
  buttonSettings: ElementRef<HTMLElement>;
  @ViewChild('buttonFilters', { read: ElementRef })
  buttonFilters: ElementRef<HTMLElement>;

  activeButton: string = 'categories';
  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    public permissionsService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActive(event.url);
      }
    });

    setTimeout(() => {
      this.buttonHome?.nativeElement.setAttribute('aria-selected', 'true');
      if (this.buttonFilters) {
        this.buttonFilters?.nativeElement.setAttribute(
          'aria-selected',
          'false'
        );
      }
      this.buttonSettings?.nativeElement.setAttribute('aria-selected', 'false');
    }, 0);
  }

  // TODO: What exactly is this for? Should this disallow all navigation?
  public isRestricted = () => {
    if (
      this.authenticationService.userInfoView &&
      this.authenticationService.userInfoView.SelectedClient
    ) {
      return this.authenticationService.userInfoView.SelectedClient
        .MQARestricted;
    }

    return true;
  };

  navigate(route: string) {
    if (route === 'settings' || route.includes('filters')) {
      this.router.navigate([route]);
    } else {
      if (!this.isRestricted()) {
        this.router.navigate([route]);
      } else {
        this.router.navigate(['restricted']);
      }
    }
  }

  private setButtonAriaSelect(
    btn: ElementRef<HTMLElement>,
    value: 'false' | 'true'
  ) {
    if (btn) {
      btn.nativeElement.setAttribute('aria-selected', value);
    }
  }

  /*
  Set the button active state based on router url path.
  */
  private setActive(route: string) {
    if (route.includes('settings')) {
      //this.buttonHome.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonHome, 'false');
      // this.buttonFilters.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonFilters, 'false');
      // this.buttonSettings.nativeElement.setAttribute('aria-selected', 'true');
      this.setButtonAriaSelect(this.buttonSettings, 'true');
    } else if (route.includes('filters')) {
      // this.buttonHome.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonHome, 'false');
      // this.buttonSettings.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonSettings, 'false');
      // this.buttonFilters.nativeElement.setAttribute('aria-selected', 'true');
      this.setButtonAriaSelect(this.buttonFilters, 'true');
    } else if (route.includes('categories')) {
      // this.buttonHome.nativeElement.setAttribute('aria-selected', 'true');
      this.setButtonAriaSelect(this.buttonHome, 'true');
      // this.buttonSettings.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonSettings, 'false');
      // this.buttonFilters.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonFilters, 'false');
    } else {
      // this.buttonHome.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonHome, 'false');
      // this.buttonSettings.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonSettings, 'false');
      // this.buttonFilters.nativeElement.setAttribute('aria-selected', 'false');
      this.setButtonAriaSelect(this.buttonFilters, 'false');
    }
  }
}
